var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChart5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.5,
    stroke: "#3F83F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.6642 9.79483L9.72472 9.72473C9.94661 9.50284 10.2938 9.48267 10.5385 9.66421L10.6086 9.72473L16 15.1158L21.3914 9.72473C21.6355 9.48066 22.0312 9.48066 22.2752 9.72473C22.5193 9.96881 22.5193 10.3645 22.2752 10.6086L16.8842 16L22.2752 21.3914C22.4972 21.6133 22.5173 21.9605 22.3357 22.2052L22.2752 22.2753C22.0534 22.4972 21.7062 22.5173 21.4615 22.3358L21.3914 22.2753L16 16.8842L10.6086 22.2753C10.3645 22.5193 9.96879 22.5193 9.72472 22.2753C9.48064 22.0312 9.48064 21.6355 9.72472 21.3914L15.1158 16L9.72472 10.6086C9.50282 10.3867 9.48266 10.0395 9.6642 9.79483L9.72472 9.72473L9.6642 9.79483Z",
    fill: "#3F83F8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart5);
export default __webpack_public_path__ + "static/media/chart5.be4996d47f4a6fd7852f031dc4607c49.svg";
export { ForwardRef as ReactComponent };